// ChatAreaLoader.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { CatLogo } from '@/components/CatLogo'; // Assuming CatLogo is accessible

{/* ========================
 * ChatAreaLoader - Loading indicator for the chat content area
 * Visually similar to GlobalOverlay but constrained and specific for chat.
 * ======================== */}
const ChatAreaLoader = ({ message = 'Loading conversation...' }) => {
  const contentVariants = {
    initial: { opacity: 0, y: 20 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        delay: 0.1
      }
    }
  };

  // Simplified progress as it's indeterminate for chat loading usually
  // You can re-add progress bar if you have determinate progress for message loading

  return (
    <motion.div
      initial="initial"
      animate="animate"
      variants={contentVariants}
      className="absolute inset-0 flex flex-col items-center justify-center z-10" // Positioned within ChatColumn
      // No background color here, assumes ChatColumn provides it or it's transparent
    >
      <div className="flex flex-col items-center space-y-6 p-4">
        {/* Loading State - Cat logo with glow animation */}
        <div className="animate-glow">
          <CatLogo
            size={32}
            className="text-primary transition-colors duration-300"
            style={{ color: 'var(--primary)' }} // Ensure color is applied
          />
        </div>

        <div className="flex flex-col items-center space-y-2">
          {/* Loading Message - Theme-aware text styling */}
          <motion.span
            className="text-sm font-medium transition-colors duration-300"
            style={{ color: 'var(--on-surface-dim)' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }} // Slight delay for message
          >
            {message}
          </motion.span>
          {/* Optional: Could add a simplified spinner or dots here if desired */}
        </div>
      </div>
    </motion.div>
  );
};

ChatAreaLoader.displayName = 'ChatAreaLoader';

export default ChatAreaLoader;